import { CustomRedirectOptions } from '~/apps/routes/RoutesTypes'
import { ADMIN_PATH, OPERATIONS_PATH } from '~/redux-modules/preferences'

/**
 * Function return list of redirect configs which should be added to the router only with specific conditions
 * @param isAdmin
 * @param showQCWorkbench
 * @param rootRedirect
 * @param isMpLevelFlagEnabled
 * @param isAutoOTEnabled
 */
export const conditionalRedirects = ({
    isAdmin,
    showQCWorkbench,
    rootRedirect,
    isAutoOTEnabled,
}: {
    rootRedirect: string
    isAdmin?: boolean
    showQCWorkbench?: boolean
    isAutoOTEnabled?: boolean
}): CustomRedirectOptions[] => {
    const routes: CustomRedirectOptions[] = [
        {
            path: '*',
            redirectTo: rootRedirect,
        },
    ]

    if (isAdmin) {
        routes.push({
            path: '/pages/quote-model-revisions/:id/viewer',
            redirectTo: '/admin/quote-model-revisions/:id',
            redirectWithParams: true,
        })
    }

    if (showQCWorkbench) {
        routes.push({
            path: `${OPERATIONS_PATH}/quality/*`,
            redirectTo: '/pages/maintenance',
        })
    }

    if (isAutoOTEnabled) {
        routes.push({
            path: [
                `${OPERATIONS_PATH}/scheduling/sales-order-details/:saleOrderName`,
                `${OPERATIONS_PATH}/scheduling/sales-order-details/:saleOrderName/:tabs`,
                `${OPERATIONS_PATH}/scheduling`,
                `${OPERATIONS_PATH}/scheduling/:tab`,
            ],
            redirectTo: `${ADMIN_PATH}/403`,
        })
    }

    return routes
}
